import { ReactNode } from 'react';

import {
  colorOrToken,
  Dialog,
  DialogProps,
  SwipeableViews,
  SlideConstructor,
  tokens,
} from '@cast/design-system';

import { Certificates } from 'components/informational/Certificates';
import { isE2E } from '@cast/utils';

type Props<S extends Record<string, ReactNode | SlideConstructor>> = Omit<
  DialogProps,
  'onClose' | 'children' | 'size'
> & {
  onClose: () => void;
  slides: S;
  activeSlide: keyof S;
  wideSlides?: string[];
};

export const SlideDialog = <
  S extends Record<string, ReactNode | SlideConstructor>
>({
  onClose,
  slides,
  activeSlide,
  wideSlides,
  ...props
}: Props<S>) => {
  return (
    <Dialog
      disableCloseOnBackdropClick
      size={wideSlides?.includes(activeSlide as string) ? 'lg' : 'md'}
      PaperProps={{
        sx: {
          overflow: 'visible',
          maxHeight: 'calc(100vh - 64px)',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
      {...props}
      onClose={onClose}
    >
      <SwipeableViews
        animateHeight={false}
        sx={{
          overflow: 'hidden',
          flex: 1,
          minHeight: 0,
          '& .react-swipeable-view-container > div': {
            maxHeight: 'calc(100vh - 100px)',
            overflow: 'hidden !important',
          },
        }}
        slides={slides}
        activeSlide={activeSlide}
        hideInactiveSlides
        disableAnimations={isE2E()}
      />
      <Certificates
        position="absolute"
        bottom={-38}
        left={32}
        color={colorOrToken('grey.200', tokens.theme.fg.structural.secondary)}
      />
    </Dialog>
  );
};
